"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: 'vertical'
  }, /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    message: "Warning",
    type: "warning",
    showIcon: true,
    closable: true
  }), /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    message: "Warning",
    description: "This is a warning notice about copywriting.",
    type: "warning",
    showIcon: true,
    closable: true
  }));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorWarning', 'colorWarningBorder', 'colorWarningBg'],
  key: 'warning'
};
var _default = exports.default = componentDemo;